import StatusLine from "./StatusLine.jsx";
import { ViteHero, ViteQa, ViteReturnProcess } from "./ViteBlocks.jsx";

const VITE = "VITE_EN_VOGUE";
const GRID = "gr-10 gr-8@tablet gr-12@mobile push-2@tablet push-1@desktop";

// Step one: identify the customer by order number plus either an email address
// or, on eBay, their eBay name.
export default function SearchPage({ data }) {
  const { labels, identifier, searchPath, introHtml, notice, channel, steps, csrfToken } = data;
  const byEbayName = identifier === "ebay_name";

  return (
    <>
      {introHtml && (
        // Copy carried over from the CMS; it is stored as HTML.
        <div dangerouslySetInnerHTML={{ __html: introHtml }} />
      )}

      <div className="customers top-buffer-m">
        {channel === VITE && <ViteHero />}

        <div className={GRID}>
          <StatusLine steps={steps} active={1} />
        </div>

        <div className={GRID}>
          <form action={searchPath} method="post" id="customers_login" className="form">
            <input type="hidden" name="authenticity_token" value={csrfToken} />

            <div className="gr-12 bottom-buffer-s">
              <label className="gr-3 gr-4@tablet gr-12@mobile" htmlFor="email">
                {byEbayName ? labels.ebayName : labels.email}
              </label>
              <span className="gr-9 gr-8@tablet gr-12@mobile">
                <input
                  id="email"
                  name="email"
                  type={byEbayName ? "text" : "email"}
                  className="form-control"
                  required
                  placeholder={byEbayName ? labels.ebayName : labels.email}
                  title={byEbayName ? labels.ebayNameError : labels.emailError}
                />
              </span>
            </div>

            <div className="gr-12 bottom-buffer-s">
              <label className="gr-3 gr-4@tablet gr-12@mobile" htmlFor="initial_order_no">
                {labels.orderNo}
              </label>
              <span className="gr-9 gr-8@tablet gr-12@mobile">
                <input
                  id="initial_order_no"
                  name="initial_order_no"
                  type="text"
                  className="form-control"
                  required
                  placeholder={labels.orderPlaceholder}
                  title={labels.orderNoError}
                />
              </span>
            </div>

            <div className="divider-number" />
            {notice && <span style={{ color: "red", fontSize: "12px" }}>{notice}</span>}

            <div className="gr-12 bottom-buffer-l">
              <button
                type="submit"
                className="button-primary gr-9 gr-8@tablet gr-12@mobile push-4@tablet push-3@desktop"
              >
                {labels.logIn}
              </button>
            </div>
          </form>
        </div>

        {channel === VITE && (
          <>
            <ViteReturnProcess />
            <ViteQa />
          </>
        )}
      </div>
    </>
  );
}
